import { Activity } from '@/types/activity';
import Cookies from 'js-cookie';
import { request } from './request';
import { tokenUtil } from './token';

export * from './formatTimestamp';
export * from './insertWhen';
export * from './useVisible';

export const cookieUtil = {
  save: ({ key = '', data = '', option = {} }) => {
    let d;
    if ('string' === typeof data) {
      d = data;
    } else if ('object' === typeof data) {
      d = JSON.stringify(data);
    }
    Cookies.set(key, d, {
      ...{
        expires: 1
      },
      ...option
    });
  },
  delete: (key = '') => {
    Cookies.remove(key);
  },
  get: (key = '') => {
    let re = null;
    if (Cookies.get(key)) {
      try {
        re = JSON.parse(Cookies.get(key));
      } catch (error) {
        re = Cookies.get(key);
      }
    }
    return re;
  }
};
/**
 * 将数组拆分为二维数组
 * @param num 单维数组长度
 * @param arr 数组
 * @param fullFill 填充值
 * @returns
 */
export const arrChange = (num = 1, arr: any[] = [], fullFill: any) => {
  let newArr = [];
  let target = JSON.parse(JSON.stringify(arr || []));
  while (target.length > 0) {
    newArr.push(target.splice(0, num));
  }
  if (fullFill !== undefined) {
    if (newArr[newArr.length - 1] && newArr[newArr.length - 1].length < num) {
      newArr[newArr.length - 1] = [
        ...newArr[newArr.length - 1],
        ...new Array(num - newArr[newArr.length - 1].length).fill(fullFill)
      ];
    }
  }
  return newArr;
};

/**
 * copr前缀转完整的corp邮箱
 */
export const corpToEmail = (corp = '') => {
  if ('' !== corp) {
    if (!corp.includes('@')) {
      if (corp.indexOf('wb.') === 0) {
        return corp + '@mesg.corp.netease.com';
      } else {
        return corp + '@corp.netease.com';
      }
    }
  }
  return corp;
};

/**
 * 把时间戳转换成xx天xx小时xx分xx秒  只计算正时间间隔
 * @param {*} sec (毫秒)
 */
export function timeLast(time: number) {
  const sec = Math.abs(time);
  let s = {
      day: Math.floor(sec / 1000 / 24 / 3600),
      hour: Math.floor((sec / 1000 / 3600) % 24),
      minute: Math.floor((sec / 1000 / 60) % 60),
      second: Math.floor((sec / 1000) % 60)
    },
    str = [];
  if (s.day > 0) {
    str.push(s.day + window.t('天'));
    str.push(s.hour + window.t('小时'));
    str.push(s.minute + window.t('分钟'));
    str.push(s.second + window.t('秒'));
  } else {
    if (s.hour > 0) {
      str.push(s.hour + window.t('小时'));
      str.push(s.minute + window.t('分钟'));
      str.push(s.second + window.t('秒'));
    } else {
      if (s.minute > 0) {
        str.push(s.minute + window.t('分钟'));
        str.push(s.second + window.t('秒'));
      } else {
        str.push(s.second + window.t('秒'));
      }
    }
  }
  return {
    timeStr: str.join(''),
    str
  };
}

//下载数据方法
export function downLoadByUrl(params: {
  url: string;
  name: string;
  format?: string;
  success?: () => void;
  error?: () => void;
}) {
  const { url, name, format = '.xlsx', success, error } = params;
  let xhr = new XMLHttpRequest();
  //GET请求,请求路径url,async(是否异步)
  xhr.open('GET', url, true);
  //设置请求头参数的方式,如果没有可忽略此行代码
  xhr.setRequestHeader('Authorization', tokenUtil.get());
  //设置响应类型为 blob
  xhr.responseType = 'blob';
  //关键部分
  xhr.onload = function () {
    //如果请求执行成功
    if (this.status === 200) {
      let blob = this.response;
      let filename = name + format; //如123.xls
      let a = document.createElement('a');
      let url = URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      //释放之前创建的URL对象
      window.URL.revokeObjectURL(url);
      success?.();
    } else {
      error?.();
    }
  };
  //发送请求
  xhr.send();
}

//点位打点
export function visitPoint(params = {}) {
  request('/frontend/visit', params);
}

export function disabledABType(activity?: Activity.IInfo) {
  return activity?.typeCls === 1 && [21, 31].includes(activity?.abExpType);
}
